<template>
  <div class="asc-hover-link" @click="handleClick">
    <asc-icon :icon="icon" :size="16" color="#057874" />
    <asc-label
      class="asc-hover-link--label"
      :value="text"
      color="#057874"
      uppercase
    ></asc-label>
  </div>
</template>

<script>
import AscIcon from '@/components/atoms/AscIcon'
import AscLabel from '@/components/atoms/AscLabel'

export default {
  name: 'AscHoverLink',

  components: {
    AscIcon,
    AscLabel,
  },

  props: {
    text: {
      type: String,
      default: '',
    },
    icon: {
      type: String,
      default: 'pencil',
    },
  },

  methods: {
    handleClick() {
      this.$emit('on-click')
    },
  },
}
</script>

<style lang="scss">
.asc-hover-link {
  background-color: $gray-100;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  padding: 4px 0;

  &--label {
    margin-left: 8px;
  }

  &:hover {
    background-color: $accent-0;
    cursor: pointer;
  }
}
</style>
